// extracted by mini-css-extract-plugin
export default {"btn":"navbar-user_btn__oAPbA"};